import React, { useState } from 'react'
import Button from '../ui/Button'

/**
 * 사이드바 액션 버튼들 컴포넌트
 */
function ActionButtons({ 
  sections, 
  generateAllTTS, 
  isGeneratingAllTTS,
  onMergeVideos,
  subtitleSettings,
  videoSettings,
  titleSettings,
  selectedVoice
}) {
  const [selectedSections, setSelectedSections] = useState([])
  const [showSectionSelector, setShowSectionSelector] = useState(false)
  const [isMergingVideos, setIsMergingVideos] = useState(false)

  // 구간 선택 토글
  const toggleSectionSelection = (sectionId) => {
    setSelectedSections(prev => {
      if (prev.includes(sectionId)) {
        return prev.filter(id => id !== sectionId)
      }
      return [...prev, sectionId]
    })
  }

  // 전체 선택/해제
  const toggleSelectAll = () => {
    if (selectedSections.length === sections.length) {
      setSelectedSections([])
    } else {
      setSelectedSections(sections.map(s => s.id))
    }
  }

  // 영상 합치기 처리
  const handleMergeVideos = async () => {
    const sectionsToMerge = selectedSections.length > 0 
      ? sections.filter(s => selectedSections.includes(s.id))
      : sections

    const missingSections = []
    sectionsToMerge.forEach(section => {
      const issues = []
      if (!section.imageFile) issues.push('이미지')
      if (!section.audioFile && !section.mp4File) issues.push('음성')
      
      if (issues.length > 0) {
        missingSections.push({
          index: section.index,
          issues: issues.join(', ')
        })
      }
    })

    if (missingSections.length > 0) {
      const message = missingSections
        .map(ms => `${ms.index}번 구간: ${ms.issues}`)
        .join('\n')
      
      const confirmed = window.confirm(
        `다음 구간에 파일이 없습니다:\n\n${message}\n\n계속 진행하시겠습니까?`
      )
      
      if (!confirmed) return
    }

    setIsMergingVideos(true)
    
    try {
      if (onMergeVideos) {
        await onMergeVideos(sectionsToMerge, {
          subtitleSettings,
          videoSettings,
          selectedVoice,
          titleSettings
        })
      }
      setShowSectionSelector(false)
      setSelectedSections([])
    } catch (error) {
      console.error('영상 합치기 실패:', error)
      alert('영상 합치기 중 오류가 발생했습니다.')
    } finally {
      setIsMergingVideos(false)
    }
  }

  return (
    <div className="sidebar-section sidebar-footer">
      {sections.length > 0 && (
        <>
          <div style={{ display: 'flex', gap: '8px', width: '100%'}}>
            <Button 
              onClick={generateAllTTS}
              variant="secondary"
              disabled={isGeneratingAllTTS}
            >
              {isGeneratingAllTTS ? '음성 생성중' : '음성 생성'}
            </Button>
            
            <Button 
              onClick={() => {
                setShowSectionSelector(!showSectionSelector)
                // 영상 합치기 버튼 클릭 시 기본적으로 전체 선택
                if (!showSectionSelector && sections.length > 0) {
                  setSelectedSections(sections.map(s => s.id))
                }
              }}
              variant="primary"
              disabled={isMergingVideos}
            >
              {isMergingVideos ? '영상 합치는 중' : '영상 합치기'}
            </Button>
          </div>

          {showSectionSelector && (
            <div className="section-selector" style={{
              marginTop: '10px',
              padding: '10px',
              border: '1px solid #444',
              borderRadius: '8px',
              background: '#2a2a2a',
              width: '100%'
            }}>
              <div style={{ marginBottom: '10px' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={selectedSections.length === sections.length}
                    onChange={toggleSelectAll}
                  />
                  <span style={{ fontSize: '13px', fontWeight: 'bold', color: 'white' }}>전체 선택</span>
                </label>
              </div>
              
              <div style={{ maxHeight: '200px', overflowY: 'auto', marginBottom: '10px' }}>
                {sections.map(section => (
                  <label 
                    key={section.id} 
                    style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '8px', 
                      padding: '4px 0',
                      cursor: 'pointer'
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedSections.includes(section.id)}
                      onChange={() => toggleSectionSelection(section.id)}
                    />
                    <span style={{ fontSize: '12px', color: 'white'}}>
                      {section.index}번 구간
                      {!section.imageFile && !section.videoFile && !section.urlMedia && ' ⚠️ 미디어 없음'}
                      {!section.audioFile && !section.mp4File && ' ⚠️ 음성 없음'}
                    </span>
                  </label>
                ))}
              </div>
              
              <div style={{ display: 'flex', gap: '8px' }}>
                <Button 
                  onClick={handleMergeVideos}
                  variant="primary"
                  style={{ flex: 1 }}
                  disabled={isMergingVideos}
                >
                  {isMergingVideos ? (
                    <>
                      <span className="spinner-icon">⏳</span>
                      <span> 합치는 중...</span>
                    </>
                  ) : '합치기 실행'}
                </Button>
                <Button 
                  onClick={() => {
                    setShowSectionSelector(false)
                    setSelectedSections([])
                  }}
                  variant="secondary"
                  style={{ flex: 1 }}
                  disabled={isMergingVideos}
                >
                  취소
                </Button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default ActionButtons
